import { HTTPError } from 'ky';

/**
 * Type guard to check if an error is an HTTPError
 */
export function isHttpError(error: unknown): error is HTTPError {
  return error instanceof HTTPError;
}

/**
 * Checks if an error is an HTTPError with a specific status code
 */
export function isHttpErrorWithStatus(
  error: unknown,
  status: number,
): error is HTTPError {
  return isHttpError(error) && error.response.status === status;
}

/**
 * Checks if an error is a 401 Unauthorized error
 */
export function isUnauthorizedError(error: unknown): error is HTTPError {
  return isHttpErrorWithStatus(error, 401);
}

/**
 * Checks if an error is a 403 Forbidden error
 */
export function isForbiddenError(error: unknown): error is HTTPError {
  return isHttpErrorWithStatus(error, 403);
}

/**
 * Checks if an error is a 404 Not Found error
 */
export function isNotFoundError(error: unknown): error is HTTPError {
  return isHttpErrorWithStatus(error, 404);
}

/**
 * Checks if an error is a 422 Unprocessable Entity error
 */
export function isUnprocessableEntityError(error: unknown): error is HTTPError {
  return isHttpErrorWithStatus(error, 422);
}
